export default "__VITE_ASSET__CdWvhy9S__"